'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:permissions
 * @description
 * # permissions
 */
angular.module('gfcmsApp')
  .directive('hasPermission', function($location, $q, cfpLoadingBar, permissionService, eventsService) {
    return {
      restrict: 'A',
      scope: {},
      link: function link(scope, element, attrs) {

        if (typeof attrs.hasPermission !== 'string') {
          return false;
        }

        var value = attrs.hasPermission.trim();
        var notPermissionFlag = value[0] === '!';
        var hasMultiplePermissions = value.indexOf('&&') > -1;

        if (notPermissionFlag) {
          value = value.slice(1).trim();
        }

        toggleVisibility();
        scope.$on(eventsService.permissionsChangedEvent, toggleVisibility);
        scope.toggleVisibility = toggleVisibility;

        function toggleVisibility() {
          var hasPermission = permissionService.hasPermission(value);

          if ((hasPermission && !notPermissionFlag) || (!hasPermission && notPermissionFlag)) {
            angular.element(element[0]).removeClass('hidden');
          } else {
            angular.element(element[0]).addClass('hidden');
          }
        }
      }
    };
  });
